module.exports = __webpack_public_path__ + "img/glyph-logo_May2016.928cef50.png";